import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Safely coerce any backend-error `detail` shape into a plain string.
 *
 * Handles:
 *   - undefined / null → "" (caller should provide a fallback)
 *   - string → returned as-is
 *   - Pydantic 422 array: [{type, loc, msg, input, ctx}, ...]
 *   - Generic object: uses .msg / .message / JSON.stringify
 *
 * This prevents React crashes like "Objects are not valid as a React child"
 * when backend returns a validation error and the UI renders it inline.
 */
export function stringifyDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (!item || typeof item !== "object") return String(item);
        const loc = Array.isArray(item.loc)
          ? item.loc.filter((p) => p !== "body").join(".")
          : "";
        const msg = item.msg || item.message || "Invalid value";
        return loc ? `${loc}: ${msg}` : msg;
      })
      .join("; ");
  }
  if (typeof detail === "object") {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return String(detail);
}
